// Delegated interception of the legacy signup CTAs, used by the A/B treatment to open the
// chatbot drawer instead of the legacy modal. Delegation at the document level (capture
// phase) covers CTAs that enter the DOM after activation — Turbo page swaps, and the mobile
// menu, whose CTA is rendered inside a popover materialised only when it opens.
// SEO crawl obfuscation renders most signup CTAs as `<span class="obf-link" data-url>` (Rails
// LinkHelper#link_obfuscate) with no href, hence the second branch.
export const SIGNUP_FLOW_LINK_SELECTOR = 'a[href*="/signup_flow"], .obf-link[data-url*="/signup_flow"]'

function isPlainPrimaryClick(event: MouseEvent): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey
}

/**
 * Routes plain left-clicks on signup CTAs to `onOpen`. Returns the uninstall function.
 * Only `preventDefault()` is called: Turbo (Drive and the remote-modal frame) honours
 * `defaultPrevented`, and the click keeps bubbling so the page's own listeners (GA
 * tracking) still observe it.
 */
export function installSignupCtaInterceptor(
  onOpen: () => void,
  { selector = SIGNUP_FLOW_LINK_SELECTOR, root = document }: { selector?: string; root?: Document | HTMLElement } = {},
): () => void {
  const handler = (event: Event): void => {
    if (!(event instanceof MouseEvent) || !isPlainPrimaryClick(event)) return
    const link = (event.target as Element | null)?.closest?.(selector)
    if (!link) return
    event.preventDefault()
    onOpen()
  }
  root.addEventListener('click', handler, true)
  return () => root.removeEventListener('click', handler, true)
}
